"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectFileUsage = exports.isMimeTypeAllowedForUsage = exports.USAGE_ALLOWED_MIME_TYPES = exports.PDF_OR_WORD_MIME_TYPES = exports.PDF_IMAGE_OR_WORD_MIME_TYPES = exports.PDF_OR_IMAGE_MIME_TYPES = exports.DRAWING_OR_PDF_MIME_TYPES = exports.DRAWING_MIME_TYPES = exports.ARCHIVE_MIME_TYPES = exports.DOCUMENT_MIME_TYPES = exports.IMAGE_MIME_TYPES = exports.USAGE_SIZE_LIMITS = exports.STUDY_DOCUMENT_SIZE_LIMIT = exports.ALLOWED_MIME_TYPES = void 0;
const usage_1 = require("./usage");
Object.defineProperty(exports, "ProjectFileUsage", { enumerable: true, get: function () { return usage_1.ProjectFileUsage; } });
// MIME-type allowlist for uploads. Each entry gives the canonical file extension
// and the per-MIME upper bound (before any usage-specific override from
// USAGE_SIZE_LIMITS).
exports.ALLOWED_MIME_TYPES = {
    // Images
    'image/jpeg': { ext: 'jpg', maxSize: 50 * 1024 * 1024 }, // 50MB
    'image/jpg': { ext: 'jpg', maxSize: 50 * 1024 * 1024 },
    'image/png': { ext: 'png', maxSize: 50 * 1024 * 1024 },
    'image/gif': { ext: 'gif', maxSize: 10 * 1024 * 1024 }, // 10MB
    'image/webp': { ext: 'webp', maxSize: 50 * 1024 * 1024 },
    'image/tiff': { ext: 'tiff', maxSize: 100 * 1024 * 1024 }, // 100MB for high-res plans
    'image/bmp': { ext: 'bmp', maxSize: 50 * 1024 * 1024 },
    // Documents
    // 300MB: a PLU règlement with its graphic plans routinely runs past 100MB.
    // Usages without an override still stop at USAGE_SIZE_LIMITS.default.
    'application/pdf': { ext: 'pdf', maxSize: 300 * 1024 * 1024 },
    'application/msword': { ext: 'doc', maxSize: 50 * 1024 * 1024 },
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': { ext: 'docx', maxSize: 50 * 1024 * 1024 },
    'text/plain': { ext: 'txt', maxSize: 10 * 1024 * 1024 },
    // Archives (for plan packages)
    'application/zip': { ext: 'zip', maxSize: 200 * 1024 * 1024 }, // 200MB
};
// Cap for the regulatory documents of an urban study (PLU, PPRI, …).
exports.STUDY_DOCUMENT_SIZE_LIMIT = 300 * 1024 * 1024; // 300MB
// Per-usage size overrides. Effective limit for a given upload is
// min(ALLOWED_MIME_TYPES[mime].maxSize, USAGE_SIZE_LIMITS[usage] ?? default).
exports.USAGE_SIZE_LIMITS = {
    // High-resolution plan documents
    [usage_1.ProjectFileUsage.PC_MATRIX]: 200 * 1024 * 1024, // 200MB
    [usage_1.ProjectFileUsage.DP_MATRIX]: 200 * 1024 * 1024,
    // Regulatory documents the architect attaches to an urban study. A PLU (and
    // its plans) or a PPRI is often far heavier than an ordinary document.
    [usage_1.ProjectFileUsage.PLU]: exports.STUDY_DOCUMENT_SIZE_LIMIT,
    [usage_1.ProjectFileUsage.PPRI]: exports.STUDY_DOCUMENT_SIZE_LIMIT,
    [usage_1.ProjectFileUsage.GEOGRAPHIC_RISK_REPORT]: exports.STUDY_DOCUMENT_SIZE_LIMIT,
    [usage_1.ProjectFileUsage.HISTORICAL_MONUMENT_MAP]: exports.STUDY_DOCUMENT_SIZE_LIMIT,
    [usage_1.ProjectFileUsage.CADASTRAL_MAP]: exports.STUDY_DOCUMENT_SIZE_LIMIT,
    [usage_1.ProjectFileUsage.URBAN_ANALYSIS]: exports.STUDY_DOCUMENT_SIZE_LIMIT,
    // Standard documents
    [usage_1.ProjectFileUsage.CERFA_DP]: 50 * 1024 * 1024, // 50MB
    [usage_1.ProjectFileUsage.CERFA_PC]: 50 * 1024 * 1024,
    [usage_1.ProjectFileUsage.CERFA_PCM]: 50 * 1024 * 1024,
    [usage_1.ProjectFileUsage.CERFA_13703_11]: 50 * 1024 * 1024,
    [usage_1.ProjectFileUsage.CERFA_13406_12]: 50 * 1024 * 1024,
    [usage_1.ProjectFileUsage.CERFA_13411_11]: 50 * 1024 * 1024,
    // Pictures and perspectives.
    // Intake + matrix photo slots are capped at 10MB: a 12MP smartphone JPEG is
    // ~3-8MB, so 10MB covers legitimate photos while cutting oversized files
    // (RAW, scans) that bloat matrix PDF generation (download + sharp + Typst all
    // scale with bytes). The PICTURE_1..6 matrix slots are listed explicitly so
    // they no longer fall back to the 50MB `default`.
    [usage_1.ProjectFileUsage.HOUSE_PICTURE]: 10 * 1024 * 1024, // 10MB
    [usage_1.ProjectFileUsage.STREET_PICTURE]: 10 * 1024 * 1024,
    [usage_1.ProjectFileUsage.GARDEN_PICTURE]: 10 * 1024 * 1024,
    [usage_1.ProjectFileUsage.PICTURE_1]: 10 * 1024 * 1024,
    [usage_1.ProjectFileUsage.PICTURE_2]: 10 * 1024 * 1024,
    [usage_1.ProjectFileUsage.PICTURE_3]: 10 * 1024 * 1024,
    [usage_1.ProjectFileUsage.PICTURE_4]: 10 * 1024 * 1024,
    [usage_1.ProjectFileUsage.PICTURE_5]: 10 * 1024 * 1024,
    [usage_1.ProjectFileUsage.PICTURE_6]: 10 * 1024 * 1024,
    [usage_1.ProjectFileUsage.PERSPECTIVE]: 50 * 1024 * 1024, // 50MB for 3D renders
    [usage_1.ProjectFileUsage.CLOSE_PERSPECTIVE]: 50 * 1024 * 1024,
    // Administrative — deposit receipt
    [usage_1.ProjectFileUsage.DEPOSIT_RECEIPT]: 50 * 1024 * 1024,
    // Commercial dossier (#584) — a full client dossier PDF can be large.
    [usage_1.ProjectFileUsage.SALES_FILE]: 100 * 1024 * 1024, // 100MB
    // Default fallback
    default: 50 * 1024 * 1024,
};
// Canonical, reusable MIME groups by category (issue #452). Every upload point
// composes its allowlist from these groups (and/or individual formats), so a
// category means the same set everywhere it is referenced.
// Full standard raster-image set — the globally-allowed image MIME types.
// HEIC/HEIF are intentionally absent (the one image family we never accept).
// `image/jpg` is the legacy alias of `image/jpeg`.
exports.IMAGE_MIME_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/tiff',
    'image/bmp',
];
// Document formats (PDF, Word, plain text).
exports.DOCUMENT_MIME_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
];
// Archive formats (plan packages).
exports.ARCHIVE_MIME_TYPES = [
    'application/zip',
];
// Composed sets reused by per-usage rules. Composing a group never broadens a
// slot's non-image acceptance: drawing views stay image-or-Word (no PDF) and
// procuration/survey stay image-or-PDF (a curated subset of DOCUMENT, by
// design), while the image portion now spans the full IMAGE group.
exports.DRAWING_MIME_TYPES = [
    ...exports.IMAGE_MIME_TYPES,
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
// Drawing views widened to also accept PDF (issue #584): a project drawing may
// arrive as an image, a Word document, or a PDF export. Superset of
// DRAWING_MIME_TYPES + PDF, still no HEIC.
exports.DRAWING_OR_PDF_MIME_TYPES = [
    'application/pdf',
    ...exports.DRAWING_MIME_TYPES,
];
exports.PDF_OR_IMAGE_MIME_TYPES = [
    'application/pdf',
    ...exports.IMAGE_MIME_TYPES,
];
// PDF, image or Word — administrative pieces that reach us in whichever form
// the client had: a scan, a PDF export, or the Word original (issue #651).
// Superset of PDF_OR_IMAGE_MIME_TYPES; still no plain text, still no HEIC.
exports.PDF_IMAGE_OR_WORD_MIME_TYPES = [
    ...exports.PDF_OR_IMAGE_MIME_TYPES,
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
// PDF or Word — the document analyses that never carried images (kept narrow,
// not the whole DOCUMENT group, so they don't start accepting plain text).
exports.PDF_OR_WORD_MIME_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
// Per-usage MIME allowlist. When a usage is listed here, uploads for that usage
// must use one of the given types — stricter than the global ALLOWED_MIME_TYPES.
// When a usage is absent, only the global allowlist applies. This is the single
// source of truth consumed by both the upload-config route (frontend hints +
// `accept` attribute) and the server-side upload-ticket validation.
exports.USAGE_ALLOWED_MIME_TYPES = {
    // Dossier intake photos — full standard image set (no HEIC). #452
    [usage_1.ProjectFileUsage.HOUSE_PICTURE]: exports.IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.STREET_PICTURE]: exports.IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.GARDEN_PICTURE]: exports.IMAGE_MIME_TYPES,
    // Matrix picture slots — full standard image set, matching the matrix UI's
    // image picker so the picker can't accept a file the upload ticket rejects.
    [usage_1.ProjectFileUsage.PICTURE_1]: exports.IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.PICTURE_2]: exports.IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.PICTURE_3]: exports.IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.PICTURE_4]: exports.IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.PICTURE_5]: exports.IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.PICTURE_6]: exports.IMAGE_MIME_TYPES,
    // Project drawing views — image, Word or PDF (#584).
    [usage_1.ProjectFileUsage.VIEW_TOP]: exports.DRAWING_OR_PDF_MIME_TYPES,
    [usage_1.ProjectFileUsage.VIEW_RIGHT]: exports.DRAWING_OR_PDF_MIME_TYPES,
    [usage_1.ProjectFileUsage.VIEW_LEFT]: exports.DRAWING_OR_PDF_MIME_TYPES,
    [usage_1.ProjectFileUsage.VIEW_FRONT]: exports.DRAWING_OR_PDF_MIME_TYPES,
    [usage_1.ProjectFileUsage.VIEW_3D_INSERTION]: exports.DRAWING_OR_PDF_MIME_TYPES,
    // Procuration and existing-survey — image or PDF.
    [usage_1.ProjectFileUsage.CLIENT_PROXY]: exports.PDF_OR_IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.EXISTING_PLANS]: exports.PDF_OR_IMAGE_MIME_TYPES,
    // Commercial dossier (#584) — image, PDF or Word (#651): the salesman's
    // dossier is often still the Word original when it is attached at intake.
    [usage_1.ProjectFileUsage.SALES_FILE]: exports.PDF_IMAGE_OR_WORD_MIME_TYPES,
    // Urban-analysis & deposit slots — image or PDF. Centralized here (#452) so
    // they widen with everything else and stop duplicating lists in the route.
    [usage_1.ProjectFileUsage.CADASTRAL_MAP]: exports.PDF_OR_IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.LOCATION_PLAN]: exports.PDF_OR_IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.AERIAL_VIEW]: exports.PDF_OR_IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.AUTHORIZED_COLOR]: exports.PDF_OR_IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.PLU]: exports.PDF_OR_IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.PPRI]: exports.PDF_OR_IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.HISTORICAL_MONUMENT_MAP]: exports.PDF_OR_IMAGE_MIME_TYPES,
    [usage_1.ProjectFileUsage.DEPOSIT_RECEIPT]: exports.PDF_OR_IMAGE_MIME_TYPES,
    // Shared documents of a study (#791): site photos, marked-up plans.
    [usage_1.ProjectFileUsage.URBAN_ANALYSIS_SHARED_DOCUMENT]: exports.PDF_OR_IMAGE_MIME_TYPES,
    // Document-only analyses — PDF or Word (no image; unchanged by #452).
    [usage_1.ProjectFileUsage.URBAN_ANALYSIS]: exports.PDF_OR_WORD_MIME_TYPES,
    [usage_1.ProjectFileUsage.GEOGRAPHIC_RISK_REPORT]: exports.PDF_OR_WORD_MIME_TYPES,
};
// Returns true when `mimeType` is acceptable for `usage`. Usages without a
// per-usage restriction fall back to the global allowlist (checked elsewhere).
const isMimeTypeAllowedForUsage = (usage, mimeType) => {
    if (!usage)
        return true;
    const allowed = exports.USAGE_ALLOWED_MIME_TYPES[usage];
    if (!allowed)
        return true;
    return allowed.includes(mimeType);
};
exports.isMimeTypeAllowedForUsage = isMimeTypeAllowedForUsage;
//# sourceMappingURL=mime.js.map